<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuthenticationFlow" });
import { Form } from "../../../../components/index.js";
import { Link, Paragraph } from "../../../../typography/index.js";
import { InputEmail } from "../../../user/index.js";
import { InboxButton } from "../../../../elements/index.js";
import Button from "../../../../elements/button/Button.svelte";
import Separator from "../../../../elements/separator/Separator.svelte";
import { useNavigate } from "svelte-navigator";
const navigate = useNavigate();
import { AUTHENTICATION } from "../../services/store.js";
import * as API from "../../services/api.js";
import { openModal } from "../../../../common/modal.js";
export let registrationUrl = "/";
export let loginUrl = "/";
let state = "default";
let error = "";
let hasEmail = $AUTHENTICATION.email !== void 0;
const setState = (newState) => {
    state = newState;
};
const onSubmit = async () => {
    const RESPONSE = await API.fetchAuthenticationTypes($AUTHENTICATION);
    hasEmail = $AUTHENTICATION.email !== void 0;
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
        return;
    }
    if (RESPONSE.includes("unknown") && registrationUrl.startsWith("#")) {
        openModal(registrationUrl);
        return;
    }
    if (RESPONSE.includes("unknown")) {
        navigate(registrationUrl, { replace: true });
        return;
    }
    if (RESPONSE.includes("blocked")) {
        state = "blocked";
        return;
    }
    if (RESPONSE.includes("credentials")) {
        state = "credentials";
        return;
    }
    if (RESPONSE.includes("token")) {
        state = "request-token";
    }
};
</script>

{#if state === 'default'}

    <Form { onSubmit } { error } id = 'check-session'>

        {#if Boolean(error)}
            <Paragraph label = { error } color = 'error' />
        {/if}

        <InputEmail bind:value = { $AUTHENTICATION.email } />

        <Button
            type = 'submit'
            icon = 'arrowRight'
            label = 'component.session.check_session.submit_button'
            css = 'w-full'
        />

    </Form>

{/if}

{#if state === 'credentials' }

    <div class = 's8-authentication'>

        <Paragraph css = '!mb-4 !mt-8'>
            Would you like to receive an access link via email?
        </Paragraph>

        {#if !hasEmail}
            <InputEmail bind:value = { $AUTHENTICATION.email } />
        {/if}

        <Button
            type = 'submit'
            icon = 'arrowRight'
            label = 'Send Sign-In Link'
            on:click = { setState.bind(null, 'request-token') }
            css = 'w-full'
        />

        <Paragraph css = 'mt-4'>
            <Separator />
            <Button
                url = { loginUrl }
                label = 'Sign in with your Password?'
                css = 'w-full'
                color = 'dark'
            />
        </Paragraph>

    </div>

{/if}

{#if state === 'request-token' }

    {#if $AUTHENTICATION.email !== undefined }

        {#await API.sendAuthenticationUrl({ email: $AUTHENTICATION.email }) then}

            <div class = 's8-authentication'>

                <Paragraph>
                    We've sent you a link to log in. Please check your
                    <span class = 'font-semibold'>{ $AUTHENTICATION.email }</span> email account.
                </Paragraph>

                <InboxButton email = { $AUTHENTICATION.email } />

                <Paragraph css = 'mt-2'>
                    Or would you like to

                    <Link
                        url = '/authentication/login'
                        label = 'log in with a different email?'
                        css = 'underline'
                    />
                </Paragraph>

            </div>

        {/await}

    {/if}

{/if}


<style>
    div.s8-authentication {
        margin-top: 20px;
    }</style>